"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _core = require("@emotion/core");

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n  width: ", "px;\n  height: ", "px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: ", " 1.5s ease-in-out infinite,\n    ", " 6s ease-in-out infinite;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  width: ", "px;\n  height: ", "px;\n  fill: none;\n  animation: ", " 2s linear infinite;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n    100%, 0% {\n      stroke: ", ";\n    }\n    40% {\n      stroke: ", ";\n    }\n    66% {\n      stroke: ", ";\n    }\n    80%, 90% {\n      stroke: ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n    0% {\n      stroke-dasharray: 1, 200;\n      stroke-dashoffset: 0;\n    }\n    50% {\n      stroke-dasharray: 89, 200;\n      stroke-dashoffset: -35;\n    }\n    100% {\n      stroke-dasharray: 89, 200;\n      stroke-dashoffset: -185;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n    100% {\n       transform: rotate(360deg);\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DefaultIndicator = function DefaultIndicator(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      indicatorContent = _ref.indicatorContent;
  var loading = theme.components.loading;
  return (0, _core.jsx)(Container, {
    size: size
  }, (0, _core.jsx)(Svg, {
    size: size
  }, (0, _core.jsx)(Path, {
    cx: loading.sizes[size].width / 2 // circle X coord
    ,
    cy: loading.sizes[size].width / 2 // circle Y coord
    ,
    r: loading.sizes[size].width / 3 // the radius is 1/3 of the width
    ,
    strokeWidth: loading.sizes[size].stroke,
    strokeMiterlimit: "10"
  })), (0, _core.jsx)(IconHolder, null, indicatorContent));
};

function rotate() {
  return (0, _theme.keyframes)(_templateObject());
}

function dash() {
  return (0, _theme.keyframes)(_templateObject2());
}

function color(theme) {
  var colors = theme.components.loading.colors;
  return (0, _theme.keyframes)(_templateObject3(), colors.color1, colors.color2, colors.color3, colors.color4);
}

var Svg = (0, _theme.styled)('svg')(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return theme.components.loading.sizes[size].width;
}, function (_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size;
  return theme.components.loading.sizes[size].width;
}, function () {
  return rotate();
});
var Path = (0, _theme.styled)('circle')(_templateObject5(), function () {
  return dash();
}, function (_ref4) {
  var theme = _ref4.theme;
  return color(theme);
});
var IconHolder = (0, _theme.styled)('div')(_templateObject6());
var Container = (0, _theme.styled)('span')(_templateObject7(), function (_ref5) {
  var theme = _ref5.theme,
      size = _ref5.size;
  return theme.components.loading.sizes[size].width;
}, function (_ref6) {
  var theme = _ref6.theme,
      size = _ref6.size;
  return theme.components.loading.sizes[size].width;
});
var _default = DefaultIndicator;
exports.default = _default;